import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'

import { FormStateContext } from '../context/FormStateContext'

const propTypes = {
  children: PropTypes.node.isRequired,
}

function FormStateProvider({ children }) {
  const [formState, setFormState] = useState({})

  const value = useMemo(() => [formState, setFormState], [formState])

  return <FormStateContext.Provider value={value}>{children}</FormStateContext.Provider>
}

FormStateProvider.propTypes = propTypes

export default FormStateProvider
